import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const affiliateCustomizationStore = useAffiliateCustomizationStore()

  const isEmbeddedPath = to.path.startsWith('/embedded')
  if (isEmbeddedPath) {
    await affiliateCustomizationStore.getActiveAffiliateCustomizations()
  }

  const isSupportedPage = affiliateCustomizationStore.isSupportedPage(to)

  if (!isSupportedPage) {
    return navigateTo('/404')
  }
});
